import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=cf8aa340&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8aa340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf8aa340')) {
      api.createRecord('cf8aa340', component.options)
    } else {
      api.reload('cf8aa340', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=cf8aa340&scoped=true&", function () {
      api.rerender('cf8aa340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28nSOcv14a224/JS/comp/Accordion.vue"
export default component.exports